import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'middleTruncate'})
export class MiddleTruncatePipe implements PipeTransform {
  transform(str: string, limit: number): string {
    return str.length > limit ? `${str.substr(0, limit - 6)  } ... ${  str.substr(str.length - 3)}` : str;
  }
}
